module.exports = __webpack_public_path__ + "static/media/18ECA9.a429ac62.jpg";